import { useInfiniteQuery } from '@tanstack/react-query';
import filesApi, { QueryFilesParams, FilesListResponse } from '@/services/apis/files';

// Query keys
export const fileKeys = {
  all: ['files'] as const,
  lists: () => [...fileKeys.all, 'list'] as const,
  list: (filters: QueryFilesParams) => [...fileKeys.lists(), filters] as const,
  detail: (id: string) => [...fileKeys.all, 'detail', id] as const,
};

export interface FilesFilters {
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  provider?: string;
  fileType?: string; // MIME type filter (e.g., 'image/*', 'video/*', 'application/pdf')
  isMediaLibrary?: boolean;
}

// Hook for fetching files with infinite scroll
export const useInfiniteFiles = (filters: FilesFilters = {}) => {
  const { limit = 20, search, sortBy = 'createdAt', sortOrder = 'desc', provider = 's3', fileType, isMediaLibrary } = filters;

  return useInfiniteQuery({
    queryKey: fileKeys.list({ limit, search, sortBy, sortOrder, provider, fileType, isMediaLibrary }),
    queryFn: async ({ pageParam }) => {
      const response = await filesApi.getFiles({
        cursor: pageParam,
        limit,
        search,
        sortBy,
        sortOrder,
        provider,
        fileType,
        isMediaLibrary,
      });
      return response;
    },
    getNextPageParam: (lastPage) => {
      return lastPage.pageInfo?.cursor || undefined;
    },
    initialPageParam: undefined as string | undefined,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
